import React, { useState, useEffect } from "react";
import { ONBOARDING_STEPS } from "../../pages/Onboarding/steps";
import { UserState, updateStage } from "../../store/reducers/stageReducer";
import useHasPermission from "../../hooks/useHasPermission";
import { useAppSelector, useAppDispatch } from "../../store/store";

interface StepProgressBarProps {
  stepKey?: keyof UserState;
  totalSteps?: number;
  currentStep?: number;
}

const StepProgressBar: React.FC<StepProgressBarProps> = ({
  stepKey,
  totalSteps,
  currentStep,
}) => {
  const { hasPermission } = useHasPermission();
  const dispatch = useAppDispatch();
  const lastPercentage = useAppSelector((state) => state.stage.lastProgressPercentage) || 0;

  //Need to remove this code after client a/b testing is complete
  const assignedFlow = useAppSelector((state) => state.login.assignedOnboardingFlow); // 2. Get the flow
  //End a/b testing code
  let total = totalSteps ?? 0;
  let current = currentStep ?? 1;

  if (stepKey) {
    const sortedSteps = [...ONBOARDING_STEPS].sort((a, b) => a.order - b.order);
    //Need to remove this code after client a/b testing is complete
    const accessibleSteps = sortedSteps.filter((step) => {
      const hasPerm = !step.permissionKey || hasPermission(step.permissionKey);
      const isSkipped = assignedFlow === "A" && step.key === "presentationComplete";
      return hasPerm && !isSkipped;
    });
    //End a/b testing code
    // const accessibleSteps = sortedSteps.filter(
    //   (step) => !step.permissionKey || hasPermission(step.permissionKey),
    // );
    total = accessibleSteps.length - 1;
    const stepIndex = accessibleSteps.findIndex((step) => step.key === stepKey);
    current = stepIndex >= 0 ? stepIndex : 1;
  }

  const targetPercentage =
    total > 0 ? Math.min(Math.max((current / total) * 100, 0), 100) : 0;

  const [animatedPercentage, setAnimatedPercentage] = useState(lastPercentage);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimatedPercentage(targetPercentage);
      dispatch(updateStage({ lastProgressPercentage: targetPercentage }));
    }, 50);

    return () => clearTimeout(timer);
  }, [targetPercentage, dispatch]);

  return (
    <div className="w-full flex flex-col gap-[15px] mb-4">
      {/* Step Label */}
      <div className="text-[#030724] font-semibold text-xl transition-all duration-300">
        STEP {current} OF {total}
      </div>

      {/* Loading Bar Container */}
      <div className="w-full h-[6px] bg-[#E7E8E9] rounded-xl overflow-hidden">
        {/* Animated Loading Bar */}
        <div
          className="h-full bg-[#E2B042] rounded-xl transition-all duration-700 ease-in-out"
          style={{ width: `${animatedPercentage}%` }}
        />
      </div>
    </div>
  );
};

export default StepProgressBar;